import React, { useState } from 'react';
import Heading from 'components/UI/Heading/Heading';
import MoneyFormat from 'components/UI/Money/MoneyFormat';
import { formatDateToString, getDateEcart } from 'library/helpers/dateUtils';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal,Button} from 'antd';
import { getNumbersBetweenDatesDayJs } from 'library/helpers/fonction';
const { confirm } = Modal;

const LocationListDetail = ({ param, currency }) => {

    const dateBegin = new Date(param?.dateDebut).toLocaleDateString('fr-FR');
    const dateEnd = new Date(param?.dateFin).toLocaleDateString('fr-FR');
    const [loaderReset , setloaderReset] = useState(false) ;
    const montantTotal = currency === 'Ar' ? param?.montantAriary : param?.montantEuro;
    const nbJours = parseInt(getNumbersBetweenDatesDayJs(param?.dateDebut, param?.dateFin)) ??0;
        
    const confimerAnnulation = () => {
    confirm({
        title: <><p><br></br>{`Voulez-vous vraiment annuler cette réservation ?`}</p></>,
        icon: <ExclamationCircleFilled />,
        content: '',
        okText: `Oui`,
        okType: 'danger',
        cancelText: 'Non',
        onOk() {
        reset();
        },
        onCancel() {
        console.log('Cancel');
        },
    });
    }

    const reset = () => {
        let title = 'Annulation réservation'; 
        let messageError = 'Ooups ! Une erreur est survenue';
        try {
            setloaderReset(true) ;
            fetch(`${process.env.REACT_APP_API_URL}/annulations/location_apres_paiement/${param.id}`, {
            method: "POST",
            headers : {
                "Content-Type": "application/json"
            },
            body: {},
            }).then(
            (res) =>
                res.json()
                .then((response => {
                    setloaderReset(false) ;
                    if (!res.ok) {
                        modalError(title, response.message);
                    }else {
                    modalInfo(title, 'Votre réservation a été annulée.');
                    }
                }))
                .catch(err => {
                    setloaderReset(false) ;
                    modalError(title, messageError);
                })
            ).catch(err => {
                setloaderReset(false) ;
                modalError(title, messageError);
            });
        }
        catch (e) {
            setloaderReset(false) ;
            modalError(title, messageError);
        }
    }
    const modalError = (title, message) => {
      Modal.error({
        title: title,
        content: message,
        onOk() {
          return;
        }
      });
    }
    return (
        <form>
            <div>
                <Heading as="h2" content={`${param?.nomLogement} ( ${param?.nomPartenaire} ) `} />
                {/* <Heading as="h3" content="Date de la réservation" /> */}
                {/* <div>{`Réservé le : ${''}`}</div> */}
                <div>{`Date d'arrivée : ${dateBegin}`}</div>
                <div>{`Date de départ : ${dateEnd}`}</div>
                <div>{`Durée totale du séjour : ${nbJours}`} nuit(s)</div> 
                <div>{`Nombre de personnes : ${param?.nombrePersonnes}`}</div>
                <div>{`Nombre de chambres : ${param?.nombreChambres}`}</div>
                <div>{`Quartier : ${param?.quartier}`}</div>
{/* 
                <div>{`Vous avez sélectionné : `}</div>
                <div>{`${param?.nbPersonneAdulte} x personne(s) `}</div> */}

                <Heading as="h3" content="Récapitulatif du montant" />
                <div>{`Total à payer : `}
                    <MoneyFormat value={montantTotal} suffix={` ${currency}`} />
                </div>

                  {
                         ( (param?.etat =='VALIDE' ) && getDateEcart(formatDateToString(new Date()) ,param.dateDebut) > 1) ?
                          <center>
                          <div style={{"margin-top" : "10px"}}>
                            <Button
                              className="back-btn"
                              onClick={confimerAnnulation} loading={loaderReset}
                            >
                              Annuler la réservation
                            </Button>
                          </div>
                          </center> : null
                        }
            </div>
        </form>
    );
};

export default LocationListDetail;